import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Logo from "../../assets/img/logo.png";
import bgImage from "../../assets/img/bg.png";
import Profile from "../../assets/img/profile.png";
import axios from "axios";
import {
  setEncryptedCookie,
  getDecryptedCookie,
  removeCookie,
} from "../../utils";
import authApi from "../../services/auth";
import { showLoader, hideLoader } from "../../redux/loader/actions";
import { showSnackbar } from "../../redux/snackbar/actions";
import { useDispatch } from "react-redux";
import { setAuth } from "../../redux/common/actions";

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const refreshAccessToken = async () => {
    try {
      const res = await authApi.refreshToken();
    } catch (err) {
      console.error("Failed to refresh access token:", err);
    }
  };

  useEffect(() => {
    refreshAccessToken();
    const intervalId = setInterval(refreshAccessToken, 14 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(showLoader());
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Logout successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        dispatch(setAuth({ isAuthenticated: false }));
        removeCookie("at");
        removeCookie("rt");
        removeCookie("abc");
        removeCookie("id");
        removeCookie("uuid");
        navigate("/");
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    authApi.logoutUser().then(onSuccess, onFailure);
    handleMenuClose();
  };

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleSettings = () => {
    navigate("/changecredentails");
    handleMenuClose();
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        margin: 0,
        padding: 0,
        boxShadow: "none",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right",
        zIndex: "1000",
      }}
    >
      <Container maxWidth="xl" sx={{ padding: 0, margin: 0 }}>
        <Toolbar disableGutters sx={{ padding: 0, margin: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#fff",
              padding: isMobile ? "5px" : "5px",
              borderRadius: "0 50px 50px 0",
              marginLeft: isMobile ? "0" : "-25px",
            }}
          >
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ padding: 0, margin: 0 }}
            >
              <img
                src={Logo}
                alt="Logo"
                style={{ height: isMobile ? "35px" : "55px" }}
              />
            </Typography>
          </Box>

          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ flexGrow: 0 }}>
            <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
              <Avatar
                alt="Profile Picture"
                src={Profile}
                sx={{ border: "3px solid #fff", boxShadow: "0 0 10px" }}
              />
            </IconButton>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleSettings}>
                <Typography textAlign="center">Settings</Typography>
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <Typography textAlign="center">Logout</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
